import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import { XYChart } from "../../../../../../components/molecules/Charts";
import { IAlertsTimeline } from "../../../../../../types";
import { useActionsHook, useTypedSelectorHook } from "../../../../../../utils";
import { CustomStack } from "./_styled.constants";

/**
 * Вкладка таймлайна за период дня Alerts Timeline - Week *
 */

export const TimelinePerWeek: React.FC = () => {
  const { alertsTimeline } = useTypedSelectorHook(({ alerts }) => alerts);
  const { getAlertsTimelineActions } = useActionsHook();
  const [timelinePerWeek, setTimelinePerWeek] = useState<IAlertsTimeline[]>([]);

  useEffect(() => {
    getAlertsTimelineActions("week");
  }, []);

  useEffect(() => {
    if (alertsTimeline) {
      setTimelinePerWeek(
        alertsTimeline.map((item) => {
          return {
            ...item,
          };
        })
      );
    }
  }, [alertsTimeline]);

  return (
    <CustomStack>
      <Typography component="span" color="primary.main">
        By quantity
      </Typography>
      <Typography component="label" color="primary.main">
        Week
      </Typography>
      <XYChart
        id="timelineWeek"
        category="time"
        value="sum"
        data={timelinePerWeek}
      />
    </CustomStack>
  );
};
